
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as resetknaAbE8PExNaSzVauanasyBLY6z6kf5BwsYT9W1SyXkMeta } from "/app/pages/auth/reset.vue?macro=true";
import { default as logoutUYmNrqQPxD4I1VCtdubU9c7hV2MRnNYob53UvKtTNwsMeta } from "/app/pages/auth/logout.vue?macro=true";
import { default as index3F3JxtW_45HNfRC4z9azC_45_45xwtY_45zd17zdCLhhUsa35dQMeta } from "/app/pages/cases/index.vue?macro=true";
import { default as createjQWOYddx49ra7UphM2AzFTiwDvXb_WAogCB68_45M43sAMeta } from "/app/pages/cases/create.vue?macro=true";
import { default as registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta } from "/app/pages/auth/register.vue?macro=true";
import { default as chartsVsMSRCSDmnbZhApjUIPpL5VB1_45xhIIOG7slhpfqla54Meta } from "/app/pages/reports/charts.vue?macro=true";
import { default as indexEMaI654t9hKzHgpQABIQ1vpqC1jQeybCFEqvB5fN_45_sMeta } from "/app/pages/outbreaks/index.vue?macro=true";
import { default as casemap5PLiWxCQTt_45oN95K7pzwLvVt6s2bGLmKoRVkk9Omp9sMeta } from "/app/pages/reports/casemap.vue?macro=true";
import { default as diseases6OVT04rFfjSv1wTAQP_J07n_PHRyEWzoYkNdGmZbtQYMeta } from "/app/pages/reports/diseases.vue?macro=true";
import { default as verificationbM4oBvUs_LE4PQnVgFXTHI2uwksUQUAY8fXuw96HK_EMeta } from "/app/pages/auth/verification.vue?macro=true";
import { default as indexzfeZIfRanqfnTlqRJg36FVk_45hq_sK6iHVpjvPjz9voEMeta } from "/app/pages/institutions/index.vue?macro=true";
import { default as mapoYVI9ppbqRT8YPZbeUcUz5ZzZJpGBNJH296HqENuZqMMeta } from "/app/pages/heat-protection/map.vue?macro=true";
import { default as institutions2_45TbFOkN_45DeZP7owe_4523SyHVOEy86v_45fFrwXY2QQYn4Meta } from "/app/pages/reports/institutions.vue?macro=true";
import { default as highriskP7E6ELvGOf1Fh7h_Bg1Q1zFoRs5YRdhbOYpnsexslSoMeta } from "/app/pages/cases/filter/highrisk.vue?macro=true";
import { default as _91caseId_93frkN8VCRaV_453dVFP5hJxUJDxgROhi6ZHPT5wqGwsBgYMeta } from "/app/pages/cases/update/[caseId].vue?macro=true";
import { default as _91caseId_93dA4KWBB6gLbGP_45r5vOvQDFwYZha0bnn0IAecmSkpxpIMeta } from "/app/pages/cases/details/[caseId].vue?macro=true";
import { default as _91status_93wBDEVjrueYtOM3owK3JCHryRHSXdnGDmGXVAPwFpSB4Meta } from "/app/pages/users/citizens/[status].vue?macro=true";
import { default as indexla_ZvSiPo6eAHJQSb8w_45N8ZRIFRJ3_45WhbQ51bnri_uEMeta } from "/app/pages/self-service/cases/index.vue?macro=true";
import { default as _91personId_93zebqYRhjOjggwz0i_ZB15IJRc4k_45aqbi9_qDZ0pKPt4Meta } from "/app/pages/users/details/[personId].vue?macro=true";
import { default as cityqCXmfUgkZ1PEG7cxnxLGo4PozU5k8GxkiRf6gRXKppEMeta } from "/app/pages/administration/users/city.vue?macro=true";
import { default as bearerTokensXpusU9svJhXKwQK8QzADFAam6KlpQm4Rfn1Wne4p5gkMeta } from "/app/pages/administration/bearerTokens.vue?macro=true";
import { default as planned_45notifications2KcRskk254V8CVTnToePGV52uQxMAOQOoN4GtbwuplEMeta } from "/app/pages/cases/planned-notifications.vue?macro=true";
import { default as registeruU_A2ttT_45EKZY2in_5_459a8WgcBWmoAV68ZgAA8epw4MMeta } from "/app/pages/auth/heat-protection/register.vue?macro=true";
import { default as on_45holdDx_qdYpsANjYMOFz55dKFAgxg2nKqQfvJd5eiAPDvW0Meta } from "/app/pages/heat-protection/calls/on-hold.vue?macro=true";
import { default as pendingRWfY_45pJ7j88_45OVRnbLyk35FKG_45wVomtdEHPkvI5AXIQMeta } from "/app/pages/heat-protection/calls/pending.vue?macro=true";
import { default as _91callId_93qtgIDLHdRzA7IZWLTKqSGTIH0WrYbj_455OFtWb2kj5_45oMeta } from "/app/pages/heat-protection/calls/[callId].vue?macro=true";
import { default as errorFJwkRBAsyu_45fo_WMf8L6IzC_snuTxXr0A7Nj2v6XdpkMeta } from "/app/pages/heat-protection/contacts/error.vue?macro=true";
import { default as indexcSFutjM0UHEaxYpTixjZPYuVTxGDqP6j4E_45AViNiGkcMeta } from "/app/pages/heat-protection/contacts/index.vue?macro=true";
import { default as callsa1PcW5FvT22rXZWZ9vyTNEYyEQ1y5JfZyXVhNgaZH_gMeta } from "/app/pages/heat-protection/warnings/calls.vue?macro=true";
import { default as index0HdGL0hNN_45XqenXj50Otpa_DEMINWNR9s4IBcoeBg_458Meta } from "/app/pages/heat-protection/warnings/index.vue?macro=true";
import { default as _91outbreakId_93iEPmFrtAJW7bSznTOt9YWT3cpQsqYoTgBf1p8UD_45oPcMeta } from "/app/pages/outbreaks/details/[outbreakId].vue?macro=true";
import { default as expiredwh3ky8PImzMFv_iACYk_45b5dO2uAC_45teOICI1WjmUU78Meta } from "/app/pages/heat-protection/contacts/expired.vue?macro=true";
import { default as postal9PHFiCq4DQJNGvP7fp0m3orRQj8WMQ9tq1NV_45jrxBBoMeta } from "/app/pages/heat-protection/hitzeknigge/postal.vue?macro=true";
import { default as indexwEY84BwPRq0njIJ1YPkXID9s0E8Q7_45aONpgfyAeccW0Meta } from "/app/pages/heat-protection/institutions/index.vue?macro=true";
import { default as _91caseId_93UguQMXj9qRSaNsCw_5aclSByGvMBeppaEe_WNupZ8aMMeta } from "/app/pages/self-service/cases/details/[caseId].vue?macro=true";
import { default as register_45svNt_opT0UqJu54yapU12_dQVoUuK8dnEY0LaZfL1wMeta } from "/app/pages/auth/heat-protection/_embed/register.vue?macro=true";
import { default as _91institutionId_93zGQIgtUYRiFelvakvJfNixM432wD5bS4Uhmr_45hddP2wMeta } from "/app/pages/institutions/details/[institutionId].vue?macro=true";
import { default as teamsWOCohmLdlMtJIAGL3A4N5d7n9QdIyq7naqreksKnNXAMeta } from "/app/pages/infection-protection/management/teams.vue?macro=true";
import { default as indexu5M_zbQXXCvG9B4Jpc5TmNHxnML7kwcIBDW0iyQkY_45MMeta } from "/app/pages/administration/templates/messages/index.vue?macro=true";
import { default as vaccinediMW63PO0Q9SbEkdFYxM8XB9lEnkcIPhV8m350_45BjrsMeta } from "/app/pages/infection-protection/management/vaccine.vue?macro=true";
import { default as indexBzSBLtY__azWIpiQ5xv_Lh9_PTWOH8L0QBNZUph2KRQMeta } from "/app/pages/administration/templates/documents/index.vue?macro=true";
import { default as symptomsVtJfcyc8mBG1FFGf1YXBP8HV49HRo06Dnpb1KZWUjsoMeta } from "/app/pages/infection-protection/management/symptoms.vue?macro=true";
import { default as import_45logs_HBc_l_45SNTQhRmECNZzTVG8tYfDbzxVrbPfjHT8O7_kMeta } from "/app/pages/infection-protection/management/import-logs.vue?macro=true";
import { default as _91contactId_9370V6rgD5s7e9OT_457zJADtbXdtORmErOb8tx1Zp4VSv4Meta } from "/app/pages/heat-protection/contacts/details/[contactId].vue?macro=true";
import { default as indexSs_45vTvnM8FfZm9evQ8gLJnnfdn2Nvd3yRATWiCac7eYMeta } from "/app/pages/infection-protection/management/disease/index.vue?macro=true";
import { default as test_45materialrZrs8kvNmcOsB2M_450jMMmQObl4atiTBVk9ZlX0BaDOAMeta } from "/app/pages/infection-protection/management/test-material.vue?macro=true";
import { default as creategjM58gWwd2hzRhcJMyASW3Cwp2_gcxy_evSjXAaaDfYMeta } from "/app/pages/infection-protection/management/disease/create.vue?macro=true";
import { default as predispositionJvXQeQKVS23pekSy0JKC0Z36RSynfqxd1HJykQkH4AgMeta } from "/app/pages/infection-protection/management/predisposition.vue?macro=true";
import { default as institution_45typesNgIV0W6ms__45aIQknQJtE3DpwlZMKAc4Gjc8ZebdtU4IMeta } from "/app/pages/infection-protection/management/institution-types.vue?macro=true";
import { default as _91templateId_93Uq_45L2mUehGLiejSaqqj3NRw_H2qsbdk0B08xxSVBS5oMeta } from "/app/pages/administration/templates/messages/update/[templateId].vue?macro=true";
import { default as _91diseaseId_93UM6zFNvw2evnWVAb6Y7cMe2YlALamF9dVL6gh9Fx9QgMeta } from "/app/pages/infection-protection/management/disease/update/[diseaseId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "auth-reset",
    path: "/auth/reset",
    meta: resetknaAbE8PExNaSzVauanasyBLY6z6kf5BwsYT9W1SyXkMeta || {},
    component: () => import("/app/pages/auth/reset.vue")
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    meta: logoutUYmNrqQPxD4I1VCtdubU9c7hV2MRnNYob53UvKtTNwsMeta || {},
    component: () => import("/app/pages/auth/logout.vue")
  },
  {
    name: "cases",
    path: "/cases",
    component: () => import("/app/pages/cases/index.vue")
  },
  {
    name: "cases-create",
    path: "/cases/create",
    component: () => import("/app/pages/cases/create.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta || {},
    component: () => import("/app/pages/auth/register.vue")
  },
  {
    name: "reports-charts",
    path: "/reports/charts",
    component: () => import("/app/pages/reports/charts.vue")
  },
  {
    name: "outbreaks",
    path: "/outbreaks",
    component: () => import("/app/pages/outbreaks/index.vue")
  },
  {
    name: "reports-casemap",
    path: "/reports/casemap",
    component: () => import("/app/pages/reports/casemap.vue")
  },
  {
    name: "reports-diseases",
    path: "/reports/diseases",
    component: () => import("/app/pages/reports/diseases.vue")
  },
  {
    name: "auth-verification",
    path: "/auth/verification",
    meta: verificationbM4oBvUs_LE4PQnVgFXTHI2uwksUQUAY8fXuw96HK_EMeta || {},
    component: () => import("/app/pages/auth/verification.vue")
  },
  {
    name: "institutions",
    path: "/institutions",
    component: () => import("/app/pages/institutions/index.vue")
  },
  {
    name: "heat-protection-map",
    path: "/heat-protection/map",
    component: () => import("/app/pages/heat-protection/map.vue")
  },
  {
    name: "reports-institutions",
    path: "/reports/institutions",
    component: () => import("/app/pages/reports/institutions.vue")
  },
  {
    name: "cases-filter-highrisk",
    path: "/cases/filter/highrisk",
    component: () => import("/app/pages/cases/filter/highrisk.vue")
  },
  {
    name: "cases-update-caseId",
    path: "/cases/update/:caseId()",
    component: () => import("/app/pages/cases/update/[caseId].vue")
  },
  {
    name: "cases-details-caseId",
    path: "/cases/details/:caseId()",
    component: () => import("/app/pages/cases/details/[caseId].vue")
  },
  {
    name: "users-citizens-status",
    path: "/users/citizens/:status()",
    component: () => import("/app/pages/users/citizens/[status].vue")
  },
  {
    name: "self-service-cases",
    path: "/self-service/cases",
    component: () => import("/app/pages/self-service/cases/index.vue")
  },
  {
    name: "users-details-personId",
    path: "/users/details/:personId()",
    component: () => import("/app/pages/users/details/[personId].vue")
  },
  {
    name: "administration-users-city",
    path: "/administration/users/city",
    component: () => import("/app/pages/administration/users/city.vue")
  },
  {
    name: "administration-bearerTokens",
    path: "/administration/bearerTokens",
    component: () => import("/app/pages/administration/bearerTokens.vue")
  },
  {
    name: "cases-planned-notifications",
    path: "/cases/planned-notifications",
    component: () => import("/app/pages/cases/planned-notifications.vue")
  },
  {
    name: "auth-heat-protection-register",
    path: "/auth/heat-protection/register",
    meta: registeruU_A2ttT_45EKZY2in_5_459a8WgcBWmoAV68ZgAA8epw4MMeta || {},
    component: () => import("/app/pages/auth/heat-protection/register.vue")
  },
  {
    name: "heat-protection-calls-on-hold",
    path: "/heat-protection/calls/on-hold",
    component: () => import("/app/pages/heat-protection/calls/on-hold.vue")
  },
  {
    name: "heat-protection-calls-pending",
    path: "/heat-protection/calls/pending",
    component: () => import("/app/pages/heat-protection/calls/pending.vue")
  },
  {
    name: "heat-protection-calls-callId",
    path: "/heat-protection/calls/:callId()",
    meta: _91callId_93qtgIDLHdRzA7IZWLTKqSGTIH0WrYbj_455OFtWb2kj5_45oMeta || {},
    component: () => import("/app/pages/heat-protection/calls/[callId].vue")
  },
  {
    name: "heat-protection-contacts-error",
    path: "/heat-protection/contacts/error",
    component: () => import("/app/pages/heat-protection/contacts/error.vue")
  },
  {
    name: "heat-protection-contacts",
    path: "/heat-protection/contacts",
    component: () => import("/app/pages/heat-protection/contacts/index.vue")
  },
  {
    name: "heat-protection-warnings-calls",
    path: "/heat-protection/warnings/calls",
    component: () => import("/app/pages/heat-protection/warnings/calls.vue")
  },
  {
    name: "heat-protection-warnings",
    path: "/heat-protection/warnings",
    component: () => import("/app/pages/heat-protection/warnings/index.vue")
  },
  {
    name: "outbreaks-details-outbreakId",
    path: "/outbreaks/details/:outbreakId()",
    component: () => import("/app/pages/outbreaks/details/[outbreakId].vue")
  },
  {
    name: "heat-protection-contacts-expired",
    path: "/heat-protection/contacts/expired",
    component: () => import("/app/pages/heat-protection/contacts/expired.vue")
  },
  {
    name: "heat-protection-hitzeknigge-postal",
    path: "/heat-protection/hitzeknigge/postal",
    component: () => import("/app/pages/heat-protection/hitzeknigge/postal.vue")
  },
  {
    name: "heat-protection-institutions",
    path: "/heat-protection/institutions",
    component: () => import("/app/pages/heat-protection/institutions/index.vue")
  },
  {
    name: "self-service-cases-details-caseId",
    path: "/self-service/cases/details/:caseId()",
    component: () => import("/app/pages/self-service/cases/details/[caseId].vue")
  },
  {
    name: "auth-heat-protection-_embed-register",
    path: "/auth/heat-protection/_embed/register",
    meta: register_45svNt_opT0UqJu54yapU12_dQVoUuK8dnEY0LaZfL1wMeta || {},
    component: () => import("/app/pages/auth/heat-protection/_embed/register.vue")
  },
  {
    name: "institutions-details-institutionId",
    path: "/institutions/details/:institutionId()",
    component: () => import("/app/pages/institutions/details/[institutionId].vue")
  },
  {
    name: "infection-protection-management-teams",
    path: "/infection-protection/management/teams",
    component: () => import("/app/pages/infection-protection/management/teams.vue")
  },
  {
    name: "administration-templates-messages",
    path: "/administration/templates/messages",
    component: () => import("/app/pages/administration/templates/messages/index.vue")
  },
  {
    name: "infection-protection-management-vaccine",
    path: "/infection-protection/management/vaccine",
    component: () => import("/app/pages/infection-protection/management/vaccine.vue")
  },
  {
    name: "administration-templates-documents",
    path: "/administration/templates/documents",
    component: () => import("/app/pages/administration/templates/documents/index.vue")
  },
  {
    name: "infection-protection-management-symptoms",
    path: "/infection-protection/management/symptoms",
    component: () => import("/app/pages/infection-protection/management/symptoms.vue")
  },
  {
    name: "infection-protection-management-import-logs",
    path: "/infection-protection/management/import-logs",
    component: () => import("/app/pages/infection-protection/management/import-logs.vue")
  },
  {
    name: "heat-protection-contacts-details-contactId",
    path: "/heat-protection/contacts/details/:contactId()",
    component: () => import("/app/pages/heat-protection/contacts/details/[contactId].vue")
  },
  {
    name: "infection-protection-management-disease",
    path: "/infection-protection/management/disease",
    component: () => import("/app/pages/infection-protection/management/disease/index.vue")
  },
  {
    name: "infection-protection-management-test-material",
    path: "/infection-protection/management/test-material",
    component: () => import("/app/pages/infection-protection/management/test-material.vue")
  },
  {
    name: "infection-protection-management-disease-create",
    path: "/infection-protection/management/disease/create",
    component: () => import("/app/pages/infection-protection/management/disease/create.vue")
  },
  {
    name: "infection-protection-management-predisposition",
    path: "/infection-protection/management/predisposition",
    component: () => import("/app/pages/infection-protection/management/predisposition.vue")
  },
  {
    name: "infection-protection-management-institution-types",
    path: "/infection-protection/management/institution-types",
    component: () => import("/app/pages/infection-protection/management/institution-types.vue")
  },
  {
    name: "administration-templates-messages-update-templateId",
    path: "/administration/templates/messages/update/:templateId()",
    component: () => import("/app/pages/administration/templates/messages/update/[templateId].vue")
  },
  {
    name: "infection-protection-management-disease-update-diseaseId",
    path: "/infection-protection/management/disease/update/:diseaseId()",
    component: () => import("/app/pages/infection-protection/management/disease/update/[diseaseId].vue")
  }
]